// PRE RMA + CSB — Réglages d'AFFICHAGE (interface épurée). Ces indicateurs ne suppriment ni fonctionnalité ni donnée :
// les composants, les routes serveur et les données existantes restent en place ; seul l'affichage à l'écran change.
// Pour réafficher un élément, passez simplement la valeur à true.
export const AFFICHAGE = {
  /** Bloc « Import consultation(s) » dans Saisie → Consultations (composant ImportConsultations, route /import conservés). */
  importConsultations: false,
  /** Bloc « Import saisie CPN » dans Saisie → CPN (composant ImportCpn, route /import conservés). */
  importCpn: false,
  /** Texte explicatif des formules sous le titre de « Gestion des intrants PEV ». */
  aideFormulesIntrantsPev: false,
} as const;

/** Nom de l'application affiché partout (en-tête, onglet du navigateur, écran de connexion). */
export const NOM_APPLICATION = 'PRE RMA + CSB';

/**
 * Section « QR de transfert PRE RMA » (écran Rapports → DHIS2) : MASQUÉE. Le code de génération du QR (shared/business-logic/qr.ts,
 * scripts/qr-generer-cas.ts, calcul `qrTransfert` côté serveur) et le QR du PDF (« PDF (avec QR) ») sont conservés intacts.
 * Pour réafficher la section à l'écran, passez simplement cette constante à true.
 */
export const AFFICHER_QR_TRANSFERT = false;
